export const environment = {
    production: false,
    // baseUrl: 'https://localhost:44392/api'
    // baseUrl: 'https://containertest.proudgrass-43671acc.westus2.azurecontainerapps.io/api'
    // baseUrl: 'https://test.api.avanceytec.com.mx/api',
    // baseUrl: 'https://test.api.lideart.com.mx/api',

    baseUrl: 'https://lideart.aytcloud.com/ApisEcommerce/api',
};